// extracted by mini-css-extract-plugin
export default {"mainLayoutWrapper":"MainLayout_mainLayoutWrapper__k54Bp","contentArea":"MainLayout_contentArea__czI-q"};